import { AdminUiExportImportView } from './admin-ui-export-import.view';

export const AdminUiExportImportController = () => {
  return <AdminUiExportImportView />;
};
